/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type HTMLAttributes, createContext, forwardRef } from 'react';
import { type ContextValue, Provider, useContextProps } from 'react-aria-components';
import { HeadingContext } from '../heading/heading.component';
import { ParagraphContext } from '../paragraph/paragraph.component';

interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const EmptyStateContext = createContext<ContextValue<EmptyStateProps, HTMLDivElement>>({});

const EmptyState = forwardRef((props: EmptyStateProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, EmptyStateContext);

  const { style, children, ...coreProps } = props;

  return (
    <div ref={ref} {...stylex.props(styles.base, style)} {...coreProps}>
      <Provider values={[
        [HeadingContext, {
          size: 24,
          weight: 'regular',
          color: 'placeholder',
        }],
        [ParagraphContext, {
          size: 14,
          weight: 'regular',
          color: 'placeholder',
        }],
      ]}>
        {children}
      </Provider>
    </div>
  );
});

const styles = stylex.create({
  base: {
    gap: 8,
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
  },
});

export { EmptyState, EmptyStateContext, type EmptyStateProps };
